// components/copilot/Lightbox.jsx
import React, { useEffect } from "react";

export default function Lightbox({ open, url, title, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="modal-backdrop"
      role="dialog"
      aria-modal="true"
      onClick={() => onClose?.()}
      style={{ zIndex: 9999 }}
    >
      <div className="modal-card" style={{ maxWidth: 980, width: "100%" }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: 0, color: "#111827" }}>{title || "Image"}</h3>
          <button className="btn-secondary" type="button" onClick={() => onClose?.()}>
            ✕
          </button>
        </div>
        <div style={{ marginTop: 10 }}>
          <img
            src={url}
            alt={title}
            style={{ width: "100%", maxHeight: "75vh", objectFit: "contain", borderRadius: 12 }}
          />
        </div>
      </div>
    </div>
  );
}
